import request from "../utils/request";

var broker = '/broker'

//排行榜数据
export function rankList () {
    return request({
        method: 'get',
        url: broker + '/v3/public/swap-points/rank',
    })
}

//开关
export function isOpenPoint (data) {
    return request({
        method: 'post',
        url: broker + '/v3/swap-points/switch',
        data,
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
    })
}

//活动总览
export function pointRuler () {
    return request({
        method: 'get',
        url: broker + '/v3/public/swap-points',
    })
}

//用户奖励总数据
export function totalUserRewardData () {
    return request({
        method: 'get',
        url: broker + '/v3/swap-points/total',
    })
}

//用户配置及余额
export function userConfigBalance () {
    return request({
        method: 'get',
        url: broker + '/v3/swap-points/userinfo',
    })
}

//用户每日数据
export function UserDailyData () {
    return request({
        method: 'get',
        url: broker + '/v3/swap-points/daily',
    })
}

//积分抽奖
export function pointLottery () {
    return request({
        method: 'post',
        url: broker + '/v3/swap-points/draw',
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
    })
}

//奖池数量
export function numberPrize () {
    return request({
        method: 'get',
        url: broker + '/v3/public/swap-points/draw-pool',
    })
}

//中奖信息
export function winInformation () {
    return request({
        method: 'get',
        url: broker + '/v3/public/swap-points/rewards',
    })
}

//积分明细
export function pointsDetails (params) {
    return request({
        method: 'get',
        url: broker + '/v3/swap-points/points',
        params
    })
}

//幸运大转盘上面的积分
export function wheelPoint () {
    return request({
        method: 'get',
        url: broker + '/v3/public/swap-points/wheel-of-fortune',
    })
}

// 未登录背景板数据
export function noTokeMsg () {
    return request({
        method: 'get',
        url: broker + '/v3/public/swap-points/sign-data',
    })
}

//用户签到
export function userSignIn () {
    return request({
        method: 'get',
        url: broker + '/v3/swap-points/user/sign',
    })
}


// WEBPACK FOOTER //
// ./src/api/contractPoint.js